import React, { useEffect, useRef, useState } from "react";
import CollapsibleTable from "../../components/CollapsibleTable/CollapsibleTable";
import SinglePage from "../../components/PdfViewer/PdfViewer";
import "./CaseDetails.css";
import { Box, IconButton, Snackbar } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import CloseIcon from "@mui/icons-material/Close";
import SaveAsIcon from '@mui/icons-material/SaveAs';
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import DoneIcon from "@mui/icons-material/Done";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useParams } from "react-router-dom";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Link, useHistory } from "react-router-dom";
import MER from "../../components/MER/MER";
import { URL } from "../../constants/constant";
import { forwardAnalyticsEvent } from "../..//util/sendAnalyticsEvent"
import Slider from '@mui/material/Slider';
import Stack from '@mui/material/Stack';
import Form from "../../components/Form/Form";

var axios = require("axios");


const CaseDetails = ({ role }) => {

  let merClickCount = useRef(0);
  let caseInfoEditClickCount =useRef(0);

  let { caseId } = useParams();
  let [digitisationResults, setDigitisationResults] = useState([]);
  let [name, setName] = useState("");
  let [labname, setLabName] = useState("");
  let [age, setAge] = useState("");
  let [Gender, setGender] = useState("");
  let [state, setState] = useState("");
  let [doctorName, setDoctorName] = useState("");
  let [registrationNum, setRegistrationNum] = useState("");
  let [declarationAvailable, setDeclarationAvailable] = useState("");
  let [Qualification, setQualification] = useState("");
  let [photo, setPhoto] = useState("");
  let [apptDate, setApptDate] = useState("");
  let [comment, setComment] = useState("");
  let [procheckComment, setProcheckComment] = useState("");

  let [testList, setTestList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [stateUpdate, setStateUpdate] = useState(false);
  const [openIncompleteDialog, setOpenIncompleteDialog] = useState(false);
  let [incompleteComments, setIncompleteComments] = useState("");
  let [verifiedComments, setVerifiedComments] = useState("");
  let [qcComments, setQcComments] = useState("");
  const [openVerifiedDialog, setOpenVerifiedDialog] = useState(false);
  const [openQcPendingDialog, setOpenQcPendingDialog] = useState(false);
  // const [base64String, setBase64String] = useState("");
  const [keyToDownload, setKeyToDownload] = useState("");
  const [allocatedUser, setAllocatedUser] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [pastUser, setPastUser] = useState(false);
  const [profile, setProfile] = useState("");
  const [isRepeatCase, setIsRepeatCase] = useState(false);
  const [repeatCaseCount, setRepeatCaseCount] = useState(0);
  const [profileName, setProfileName] = useState("");
  const [pmId, setPmId] = useState("");
  const [hasMer, setHasMer] = useState("false");
  const [hasDoctorForm, setHasDoctorForm] = useState("false");
  const loggedInUser = JSON.parse(
    localStorage.getItem("loggedInUserDetails")
  ).emailId.split("@")[0];
  const [editable, setEditable] = useState(true);
  const [editCaseInfo, setEditCaseInfo] = useState(false);
  const [message, setMessage] = useState();
  const [openSnackbar, setOpenSnackBar] = useState(false);
  const [testingCase, setTestingCase] = useState("");
  const [testPage, setTestPage] = useState(1);
  const [openMer, setOpenMer] = useState(false);
  const [openDoctorForm, setOpenDoctorForm] = useState(false);
  const [abled, setAbled] = useState(false);
  const [MerFilled, setMerFilled] = useState(false);
  const [doctorFormFilled, setDoctorFormFilled] = useState(true)
  const [formType, setFormType] = useState();
  const [preSignedUrl, setPreSignedUrl] = useState('');
  const [reportFileType, setReportFileType] = useState('');
  const history = useHistory(); //navigation
  let [lisFlag, setLisFlag] = useState(false);
  const [anomalyThresholdValue, setAnomalyThresholdValue] = useState(0);
  const [openPushToDoctorEntry, setOpenPushToDoctorEntry] = useState(false)
  const[nonWhite,setnonWhite] = useState(true)
  const [isFitnessDropdownNeeded, setIsFitnessDropdownNeeded] = useState(false);
  let [pehcDropdownValue, setPehcDropdownValue] = useState("");  
  // PEHC dropdown mapping - UI text to API ID
  const pehcDropdownOptions = [
    { label: "Fit", value: 98 },
    { label: "Unfit", value: 97 },
    { label: "Fit with Recommendation", value: 126 },
    { label: "Fitness on Hold", value: 127 },
    { label: "Temporary Unfit", value: 128 }
  ];

  //snackbar
  const handleSnackbar = () => {
    setOpenSnackBar(true);
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackBar(false);
  };

  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleCloseSnackbar}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  const assignSnackbarContent = (content) => {
    setMessage(content);
    handleSnackbar();
  };
  

  const handleSave = () => {
    setIsOpen(true);
  };

  const handlePushQCClose = () => {
    setOpenQcPendingDialog(false);
  };

  const handlePushQCOpen = () => {
    setOpenQcPendingDialog(true);
  };

  const handlePushDoctorEntryOpen = () => {
    setOpenPushToDoctorEntry(true)
  }

  const handlePushDoctorEntryClose = () => {
    setOpenPushToDoctorEntry(false)
  }

  const handlePushDoctorEntry = () => {
    setStateUpdate(true);
    var data = JSON.stringify({
      case_id: caseId,
      state: "Doctor Entry Pending",
      remarks: "Pushing for Doctor Entry",
      user: loggedInUser,
      testingCase: testingCase === "true" ? "true" : "false",
    });

    var config = {
      method: "post",
      url: URL.demystify_url + "basicCaseData/update-status-v2/",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        //console.log(JSON.stringify(response.data));
        if (response.data.success == 1) {
          setStateUpdate(false);
          assignSnackbarContent(`Successfully pushed for Doctor Entry`);
          setEditable(false);
          //setForceRefetchCounter(forceRefetchCounter + 1);

        } else {
          setStateUpdate(false);
          assignSnackbarContent(
            `Something wrong happened , Error message: ${response.data.errorMessage}`
          );
        }
      })
      .catch(function (error) {
        alert(error);
        console.log(error);
      });

    forwardAnalyticsEvent("PushDoctorEntryButtonClick", { caseId: caseId, currentStatus: state, repeatCaseCount: repeatCaseCount });

    handlePushDoctorEntryClose()
  }

  const handlePushQC = () => {
    setStateUpdate(true);
    var data = JSON.stringify({
      case_id: caseId,
      state: "QC Pending",
      remarks: qcComments,
      user: loggedInUser,
      testingCase: testingCase === "true" ? "true" : "false",
    });

    if (!qcComments) {
      alert("Please pass comments");
      return;
    }

    forwardAnalyticsEvent("PushQCButtonClick", { caseId: caseId, currentStatus: state, repeatCaseCount: repeatCaseCount });


    var config = {
      method: "post",
      url: URL.demystify_url + "basicCaseData/update-status-v2/",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
 
    axios(config)
      .then(function (response) {
        // console.log(JSON.stringify(response.data));
        if (response.data.success == 1) {
          setStateUpdate(false);
          assignSnackbarContent(`Successfully pushed for QC`);
          setEditable(false);
          //setForceRefetchCounter(forceRefetchCounter + 1);

        } else {
          setStateUpdate(false);
          assignSnackbarContent(
            `Something wrong happened , Error message: ${response.data.errorMessage}`
          );
        }
      })
      .catch(function (error) {
        alert(error);
        console.log(error);
      });

    setOpenQcPendingDialog(false);
    //window.reload();
  };

  const handleIncompleteClickOpen = () => {
    setOpenIncompleteDialog(true);
  };

  const handleIncompleteClose = () => {
    setOpenIncompleteDialog(false);
  };

  const handleIncomplete = () => {
    //call status change api here to change status to incomplete


    setStateUpdate(true);
    var data = JSON.stringify({
      case_id: caseId,
      state: "INCOMPLETE",
      remarks: incompleteComments,
      user: loggedInUser,
      testingCase: testingCase === "true" ? "true" : "false",
    });

    if (!incompleteComments) {
      alert("Please pass comments");
      return;
    }

    forwardAnalyticsEvent("CaseIncompleteButtonClick", { caseId: caseId, currentStatus: state, repeatCaseCount: repeatCaseCount });


    var config = {
      method: "post",
      url: URL.demystify_url + "basicCaseData/update-status-v2/",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        //console.log(JSON.stringify(response.data));
        if (response.data.success == 1) {
          setStateUpdate(false);
          assignSnackbarContent(`Successfully marked incomplete`);
          setEditable(false);
          //setForceRefetchCounter(forceRefetchCounter + 1);
        } else {
          setStateUpdate(false);
          assignSnackbarContent(
            `Something wrong happened , Error message: ${response.data.errorMessage}`
          );
        }
      })
      .catch(function (error) {
        alert(error);
        console.log(error);
      });

    setOpenIncompleteDialog(false);
  };

  const handleVerifiedClose = () => {

    setOpenVerifiedDialog(false);
  };


  const handleVerifiedOpen = () => {
    // Check if PEHC dropdown is required and not selected
    if (isFitnessDropdownNeeded && !pehcDropdownValue) {
      alert("PEHC Options is a mandatory field. Please select an option before proceeding.");
      return;
    }
    setOpenVerifiedDialog(true);
  };

  const handleVerified = () => {


    //call status change api here to change status to verified
    setStateUpdate(true);
    var data = JSON.stringify({
      case_id: caseId,
      state: "VERIFIED",
      remarks: verifiedComments,
      user: loggedInUser,
      testingCase: testingCase === "true" ? "true" : "false",
      autoMovementToStatus: pehcDropdownValue,
    });

    if (!verifiedComments) {
      alert("Please pass comments");
      return;
    }

    forwardAnalyticsEvent("CaseVerifyButtonClick", { caseId: caseId, currentStatus: state, repeatCaseCount: repeatCaseCount });


    var config = {
      method: "post",
      url: URL.demystify_url + "basicCaseData/update-status-v2/",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
  
    axios(config)
      .then(function (response) {
        // console.log(JSON.stringify(response.data));
        if (response.data.success == 1) {
          setStateUpdate(false);
          assignSnackbarContent(`Successfully marked as verified`);
          setEditable(false);
          //setForceRefetchCounter(forceRefetchCounter + 1);
        } else {
          setStateUpdate(false);
          assignSnackbarContent(
            `Something wrong happened , Error message: ${response.data.errorMessage}`
          );
        }
      })
      .catch(function (error) {
        alert(error);
        console.log(error);
      });

    setOpenVerifiedDialog(false);
  };

  const handleEdit = () => {
    if (editCaseInfo) {
      var data = JSON.stringify({
        caseId: caseId,
        digitization_results: rows,
        caseInfo: { name: name, labName: labname, age: age, gender: Gender, doctorName: doctorName, registrationNum: registrationNum, declarationAvailable: declarationAvailable, qualification: Qualification, photo: photo, appointmentDate: apptDate, comment: comment }
      });
      
      forwardAnalyticsEvent("CaseBasicDetailsSaveClicked", { caseId: caseId, currentStatus: state, repeatCaseCount: repeatCaseCount });
    
      var config = {
        method: "post",
        url: URL.demystify_url + "caseDetails/saveCaseDetails/",
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
        },
        data: data,
      };

      axios(config)
        .then(function (response) {
          assignSnackbarContent("Changes saved");
          setEditCaseInfo(false)
        })
        .catch(function (error) {
          alert(error);
          assignSnackbarContent("An error occurred");
          console.log(error);
        });
    }
    else {
      if (caseInfoEditClickCount.current == 0) {
        forwardAnalyticsEvent("CaseInfoEditClicked", { caseId: caseId, currentStatus: state, repeatCaseCount: repeatCaseCount });
        caseInfoEditClickCount.current += 1
      }
      setEditCaseInfo(true);
    }
  };

  const handlePageChange = (page) => {
    setTestPage(page);
  };

  const [rows, setRows] = useState([]); //set parents state from here
  const [rows2, setRows2] = useState([]);

  const [forceRefetchCounter, setForceRefetchCounter] = useState(0);
 

  useEffect(() => {
    //call api here to fetch all case details including digitisationResults
    let caseStatus = undefined;
    let currentRepeaCaseCount = undefined;

    var config = {
      method: "get",
      url: URL.demystify_url + "caseDetails/fetchCase/" + caseId,
      headers: {
        accept: "application/json",
      },
    };

    setLoading(true);

    axios(config)
      .then(function (response) {
        let res = response.data;
        setDigitisationResults(res["digitization_results"]);

        setName(res["name"]);
        setLabName(res["labName"]);
        setAge(res["age"]);
        setGender(res["gender"]);
        setState(res["status"] || "");
        caseStatus = res["status"];
        setDoctorName(res["doctorName"]);
        setRegistrationNum(res["registrationNumber"]);
        setDeclarationAvailable(res["declarationAvailable"]);
        setQualification(res["doctorQualification"]);
        setPhoto(res["photographAvailable"]);
        setApptDate(res["actualAppointmentDate"].split("T")[0]);
        setComment(res["remarks"]);
        setProcheckComment(res["comment"]);
        setIsFitnessDropdownNeeded(res["isFitnessDropdownNeeded"]);


        setTestList(Array.isArray(res["packageList"]) ? res["packageList"] : JSON.parse(res["packageList"].replace(/'/g, '"')));
        const downloadKey = res.key?.split("/")[0].includes("-")
          ? res.key.split("/")[0].split("_")[0]
          : res.key?.split("/")[1].split("_")[0] ?? "";
        setKeyToDownload(downloadKey);
        setAllocatedUser(res["allocated_to"]);
        setProfile(res["profile"]);
        setTestingCase(res["testingCase"]);
        setPastUser(
          loggedInUser != res["allocated_to"] &&
          (loggedInUser == res["data_entry_user"] ||
            loggedInUser == res["qc_user"])
        );
        setIsRepeatCase(res["isRepeatCase"]);
        setRepeatCaseCount(res["repeatCaseCount"] || 0);
        currentRepeaCaseCount = res["repeatCaseCount"] || 0;
        setProfileName(res["profileName"]);
        setPmId(res["pmEntityId"]);
        setMerFilled(res["isMERcompletelyFilled"]);

        setHasMer(res["hasMER"] || res?.workflow?.mer || res["pmEntityId"] == "1049413");
        setHasDoctorForm(res?.workflow?.doctorForm || false || res["pmEntityId"] == "1049413");
        setFormType(res["formType"]);

        if (forceRefetchCounter == 0) {
          forwardAnalyticsEvent("CaseDetailsPageOpened", {
            caseId: caseId,
            currentStatus: caseStatus,
            repeatCaseCount: currentRepeaCaseCount || 0
          });
        }

        const sortedRows = getSortedRows(res["digitization_results"]);
        const splitRows = splitSortedRowGroups(sortedRows);
        
        setRows(splitRows);
        setRows2(splitRows);
        setReportFileType(res["reportContentType"]);
        // Assuming 'res' is your response object
        if (res.hasOwnProperty("lisLabSpcCode")) {
          setLisFlag("Available");
        } else {
          setLisFlag(null);  // or setLisFlag("");
        }

        var data2 = JSON.stringify({
          key: res["key"],
          bucket: res["reportPdfBucket"],
          send_URL: 1,
        });
        var config2 = {
          method: "post",
          url: URL.demystify_url + "caseDetails/fetchBase64pdf/",
          headers: {
            "Content-Type": "application/json",
          },
          data: data2,
        };

        axios(config2)
          .then(function (response) {
            console.log(response.data)
            setPreSignedUrl(response.data);
            setLoading(false);
          })
          .catch(function (error) {
            alert(error);
            setLoading(false);
            console.log(error);
          });
      })
      .catch(function (error) {
        setLoading(false);
        alert(error);
        console.log(error);
      });


  }, [forceRefetchCounter]);


  const getSortedRows = (rows) => {
    let rearragedRows = rows?.sort((a, b) => {
      let isValueMissingInA = a.extractedResults?.some(item => !item.value);
      let isValueMissingInB = b.extractedResults?.some(item => !item.value);

      if ((!isValueMissingInA && !isValueMissingInB) || (isValueMissingInA && isValueMissingInB)) {
        return 0;
      }
      else if (isValueMissingInA && !isValueMissingInB) {
        return -1;
      }
      else if (isValueMissingInB && !isValueMissingInA) {
        return 1;
      }
    });

    return rearragedRows;
  }

  const splitSortedRowGroups = (sortedRows) => {
    //these are already sorted by if they have missing packages
    let finalSortedRows = [];
    sortedRows.forEach((row) => {
      if (row.extractedResults) {
        let sortedExtractedResults = []
        //first add all the empty rows
        row.extractedResults.forEach((extractedResult) => {
          if (!extractedResult.name) {
            sortedExtractedResults.push(extractedResult)
          }
        })
        //then add the rows that are not empty but have missing anomaly_scores
        row.extractedResults.forEach((extractedResult) => {
          if (extractedResult.name && !extractedResult.anomaly_scores) {
            sortedExtractedResults.push(extractedResult)
          }
        })
        const rowsWithAnomalyScores = []
        row.extractedResults.forEach((extractedResult) => {
          if (extractedResult.name && extractedResult.anomaly_scores) {
            rowsWithAnomalyScores.push(extractedResult)
          }
        })
        //now sort the rows with anomaly scores based on reconstruction loss
        rowsWithAnomalyScores.sort((a, b) => {
          return b.anomaly_scores.reconstruction_loss - a.anomaly_scores.reconstruction_loss
        })
        sortedExtractedResults = [
          ...sortedExtractedResults, ...rowsWithAnomalyScores
        ]
        //finally push this to the final sorted rows
        finalSortedRows.push({
          ...row,
          extractedResults: sortedExtractedResults
        })

      }
      else {
        finalSortedRows.push(row)
      }
    })
    return finalSortedRows

  }





  const toggleMER = () => {
    setOpenMer(!openMer);
  };
  const toggleDoctorForm = () => {
    setOpenDoctorForm(!openDoctorForm);
  };

  const CustomTextField = (val, stateFun) => {
    return (
      <TextField
        size="small"
        fullWidth
        autoComplete="off"
        value={val}
        onChange={(e) => {
          stateFun(e.target.value);
        }}
        variant="standard"
        inputProps={{ style: { color: "white" } }}
      />
    );
  };

  const CustomSelect = (val, stateFun) => {
    return (
      <Select
        value={val}
        onChange={(e) => {
          stateFun(e.target.value);
        }}
        size="small"
        inputProps={{ style: { color: "white" } }}
      >
        <MenuItem value={"Yes"}>Yes</MenuItem>
        <MenuItem value={"No"}>No</MenuItem>
      </Select>
    );
  };

  return (
    <>
      {loading ? (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : role == "Admin" || loggedInUser == allocatedUser || pastUser ? (
        openMer ? (
          (profile === "Corporate") ? (
            <Form
              toggle={toggleMER}
              caseId={caseId}
              abled={abled}
              setAbled={setAbled}
              editable={editable}
              loggedInUser={loggedInUser}
              setFormFilled={setDoctorFormFilled}
              status={state}
              repeatCaseCount={repeatCaseCount}
              preSignedUrl={preSignedUrl}
              formType={"MER"}
            >
            </Form>) : (
            <MER
              toggleMER={toggleMER}
              profile={profile}
              profileName={profileName}
              pmId={pmId}
              caseId={caseId}
              abled={abled}
              setAbled={setAbled}
              editable={editable}
              loggedInUser={loggedInUser}
              setFormFilled={setMerFilled}
              formType={formType}
              status={state}
              repeatCaseCount={repeatCaseCount}
            />
          )
        ) : openDoctorForm ? (
          <Form
            toggle={toggleDoctorForm}
            caseId={caseId}
            abled={abled}
            setAbled={setAbled}
            editable={editable}
            loggedInUser={loggedInUser}
            setFormFilled={setDoctorFormFilled}
            status={state}
            repeatCaseCount={repeatCaseCount}
            preSignedUrl={preSignedUrl}
            formType={"Doctor"}
          >
          </Form>
        ) : (
          <div className="parentContainer">
            <Dialog open={openIncompleteDialog} onClose={handleIncompleteClose}>
              <DialogTitle>Mark as Incomplete</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  Do you want to mark this case as incomplete?
                </DialogContentText>
                <TextField
                  autoFocus
                  autoComplete="off"
                  margin="dense"
                  id="comments"
                  label="Comments"
                  type="text"
                  fullWidth
                  variant="standard"
                  value={incompleteComments || comment}
                  onChange={(event) =>
                    setIncompleteComments(event.target.value)
                  }
                  required
                />
              </DialogContent>
              <DialogActions>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={handleIncompleteClose}
                >
                  Cancel
                </Button>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={handleIncomplete}
                >
                  Mark Incomplete
                </Button>
              </DialogActions>
            </Dialog>
            <Dialog open={openVerifiedDialog} onClose={handleVerifiedClose}>
              <DialogTitle>Mark as Verified</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  Do you want to mark this case as verified?
                </DialogContentText>
                <TextField
                  autoFocus
                  autoComplete="off"
                  margin="dense"
                  id="verifiedComments"
                  label="Comments"
                  type="text"
                  fullWidth
                  variant="standard"
                  value={verifiedComments}
                  onChange={(event) => setVerifiedComments(event.target.value)}
                  required
                />
              </DialogContent>
              <DialogActions>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={handleVerifiedClose}
                >
                  Cancel
                </Button>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={handleVerified}
                >
                  Mark Verified
                </Button>
              </DialogActions>
            </Dialog>
            <Dialog open={openQcPendingDialog} onClose={handlePushQCClose}>
              <DialogTitle>Push for QC</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  Do you want to push this case for QC?
                </DialogContentText>
                <TextField
                  autoFocus
                  autoComplete="off"
                  margin="dense"
                  id="qcComments"
                  label="Comments"
                  type="text"
                  fullWidth
                  variant="standard"
                  value={qcComments}
                  onChange={(event) => setQcComments(event.target.value)}
                  required
                />
              </DialogContent>
              <DialogActions>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={handlePushQCClose}
                >
                  Cancel
                </Button>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={handlePushQC}
                >
                  Push for QC
                </Button>
              </DialogActions>
            </Dialog>
            <Dialog open={openPushToDoctorEntry} onClose={handlePushDoctorEntryClose}>
              <DialogTitle>Push for Doctor Entry</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  Do you want to push this case for Doctor Entry?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={handlePushDoctorEntryClose}
                >
                  Cancel
                </Button>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={handlePushDoctorEntry}
                >
                  Push for Doctor Entry
                </Button>
              </DialogActions>
            </Dialog>
            <div className="split left">
              {/* //pdf viewer */}
              <div>
                <SinglePage
                  // base64String={base64String}
                  reportFileType={reportFileType}
                  preSignedUrl={preSignedUrl}
                  keyToDownload={keyToDownload}
                  testPage={testPage}
                  setTestPage={setTestPage}
                  labName={labname}
                />
                <div style={
                  {
                    'display': 'flex',
                    'justifyContent': 'center',
                    'alignItems': 'center',

                  }
                }>

                  <Box sx={{ width: 200 }}>
                    {
                      !loading ?
                        <Slider aria-label="Volume" value={anomalyThresholdValue} valueLabelDisplay="auto" onChange={(e, val) => {
                          setAnomalyThresholdValue(val)
                        }} />
                        : <>
                        </>
                    }
                    <div>anomaly ignore strength</div>
                  </Box>
              

                </div>
              </div>
            </div>

            <div className="split right">
              <div>
                <div className="rightHeader">
                  <div className="firstDiv">
                    <div className="CaseId">Case ID:</div>
                    <div style={{ marginLeft: 5 }}>{caseId}</div>
                    {lisFlag && (
                      <>
                        <div className="LisFlagDiv">LIS :</div>
                        <div className="LisFlagValue" style={{ marginLeft: 5 }}>{lisFlag}</div>
                      </>
                    )}

                    { }
                    <Box
                      display="flex"
                      visibility={pastUser ? "hidden" : "visible"}
                      className="status-change"
                    >
                      <IconButton onClick={() => history.goBack()}>
                        <ArrowCircleLeftIcon
                          sx={{ fontSize: 40 , color: "#4095f7" }}
                        />
                      </IconButton>
                      <div className="btn-save">
                        <Button
                          variant="contained"
                          endIcon={<SaveIcon />}
                          onClick={handleSave}
                        >
                          Save
                        </Button>
                      </div>
                      <IconButton
                        sx={{
                          color: "#4095f7",
                          marginLeft: 5,
                          border: 1,
                          borderRadius: 2,
                        }}
                        className="icon"
                        onClick={handleEdit}
                      >
                        {editCaseInfo ? <SaveAsIcon /> : <ModeEditIcon />}
                      </IconButton>
                      <IconButton
                        sx={{
                          display:
                            editable &&
                              (state == "QC Pending" ||
                                (profile == "Corporate" && profileName !== "Adani_AHC" &&
                                  state == "Data Entry Pending"))
                              ? ""
                              : "none",
                          fontSize: 33,
                          color: "#4095f7",
                          marginLeft: 3,
                          border: 1,
                          borderRadius: 2,
                        }}
                        className="icon"
                        onClick={handleVerifiedOpen}
                      >
                        <DoneIcon />
                      </IconButton>
                      <IconButton
                        sx={{
                          display:
                            editable &&
                              (state == "QC Pending" ||
                                state == "Data Entry Pending")
                              ? ""
                              : "none",

                          color: "#4095f7",
                          marginLeft: 3,
                          border: 1,
                          borderRadius: 2,
                        }}
                        className="icon"
                        onClick={handleIncompleteClickOpen}
                      >
                        <QuestionMarkIcon />
                      </IconButton>
                      <Button
                        sx={{
                          display:
                            editable &&
                              (state == "Data Entry Pending" &&
                                profile != "Corporate") || (state === "Doctor Entry Pending")
                              ? ""
                              : "none",
                          color: "#4095f7",
                          marginLeft: 3,
                          border: 1,
                          borderRadius: 2,
                        }}
                        onClick={handlePushQCOpen}
                        disabled={!MerFilled && !doctorFormFilled}
                      >
                        Push for QC
                      </Button>
                      <Button
                        sx={{
                          display:
                            editable &&
                              (state == "Data Entry Pending" || state == "LIS Data Available") &&
                              profile === "Corporate" &&
                              (profileName === "Adani_AHC" || profileName === "Adani_PEHC")
                              ? ""
                              : "none",
                          color: "#4095f7",
                          marginLeft: 3,
                          border: 1,
                          borderRadius: 2,
                        }}
                        onClick={handlePushDoctorEntryOpen}
                        disabled={!MerFilled && !doctorFormFilled}
                      >
                        Push for Doctor Entry
                      </Button>
                      {hasMer && (
                        <Button
                          variant="outlined"
                          sx={{
                            color: "#4095f7",
                            marginLeft: 3,
                            border: 1,
                            borderRadius: 2,
                          }}
                          onClick={() => {
                            if (merClickCount.current == 0) {
                              
                              forwardAnalyticsEvent("MERButtonClicked", { caseId: caseId, currentStatus: state, repeatCaseCount: repeatCaseCount });
                              merClickCount.current = merClickCount.current + 1
                            }
                            setOpenMer(true)
                          }}
                        >
                          MER
                        </Button>
                      )}
                      {hasDoctorForm && ['Doctor Entry Pending', "QC Pending", "VERIFIED"].includes(state) && (
                        <Button
                          variant="outlined"
                          sx={{
                            color: "#4095f7",
                            marginLeft: 3,
                            border: 1,
                            borderRadius: 2,
                          }}
                          onClick={() => {
                            if (merClickCount.current == 0) {
                              forwardAnalyticsEvent("DoctorFormButtonClicked", { caseId: caseId, currentStatus: state, repeatCaseCount: repeatCaseCount });
                              merClickCount.current += 1
                            }
                            setOpenDoctorForm(true)
                          }}
                        >
                          Doctor Form
                        </Button>
                      )}
                    </Box>
                  </div>

                  <div className="infoDiv">
                    <div style={{ display: "flex" }}>
                      <div className="info-pair">
                        {" "}
                        <span className="cyan">Name: </span>{" "}
                        {editCaseInfo ? CustomTextField(name, setName) : name}{" "}
                      </div>
                      <div style={{ marginLeft: 30 }} className="info-pair">
                        {" "}
                        <span className="cyan">Lab Name: </span>{" "}
                        {editCaseInfo
                          ? CustomTextField(labname, setLabName)
                          : labname}{" "}
                      </div>
                    </div>
                    <div style={{ display: "flex", marginTop: 5 }}>
                      <div className="info-pair">
                        {" "}
                        <span className="cyan">Age: </span>{" "}
                        {editCaseInfo ? CustomTextField(age, setAge) : age}{" "}
                      </div>
                      <div style={{ marginLeft: 50 }} className="info-pair">
                        {" "}
                        <span className="cyan">Gender: </span>{" "}
                        {editCaseInfo
                          ? CustomTextField(Gender, setGender)
                          : Gender}{" "}
                      </div>
                      <div style={{ marginLeft: 50 }} className="info-pair">
                        {" "}
                        <span className="cyan">State: </span> {state}{" "}
                      </div>
                    </div>
                    <div style={{ display: "flex", marginTop: 5 }}>
                      <div className="info-pair">
                        {" "}
                        <span className="cyan">Doctor Name: </span>{" "}
                        {editCaseInfo
                          ? CustomTextField(doctorName, setDoctorName)
                          : doctorName}{" "}
                      </div>
                      <div style={{ marginLeft: 30 }} className="info-pair">
                        {" "}
                        <span className="cyan">Registration Number: </span>{" "}
                        {editCaseInfo
                          ? CustomTextField(registrationNum, setRegistrationNum)
                          : registrationNum}{" "}
                      </div>
                      <div style={{ marginLeft: 30 }} className="info-pair">
                        {" "}
                        <span className="cyan">Declaration available: </span>{" "}
                        {/* {editCaseInfo ? CustomTextField(declarationAvailable, setDeclarationAvailable) : (declarationAvailable ==="" || declarationAvailable==="False") ? "False" : "True"}{" "} */}
                        {!editCaseInfo && (declarationAvailable === "" || declarationAvailable === "False" ? "False" : "True")}{" "}
                        {editCaseInfo &&
                          <div>

                            <label>
                              <input
                                type="checkbox"
                                checked={declarationAvailable === "True"}
                                value="True"
                                onClick={(e) => setDeclarationAvailable(e.target.value)}
                              />
                              True
                            </label>

                            <label>
                              <input
                                type="checkbox"
                                checked={declarationAvailable === "False" || declarationAvailable === ""}
                                value="False"
                                onClick={(e) => setDeclarationAvailable(e.target.value)}
                              />
                              False
                            </label>
                          </div>
                        }
                      </div>
                    </div>
                    <div style={{ display: "flex", marginTop: 5 }}>
                      <div className="info-pair">
                        {" "}
                        <span className="cyan">Doctor Qualification: </span>{" "}
                        {editCaseInfo
                          ? CustomTextField(Qualification, setQualification)
                          : Qualification}{" "}
                      </div>
                      <div style={{ marginLeft: 30 }} className="info-pair">
                        {" "}
                        <span className="cyan">Photograph available: </span>{" "}
                        {!editCaseInfo && photo}
                        {editCaseInfo &&
                          <div>
                            <label>
                              <input
                                type="checkbox"
                                checked={photo === "True"}
                                value="True"
                                onClick={(e) => setPhoto(e.target.value)}
                              />
                              True
                            </label>

                            <label>
                              <input
                                type="checkbox"
                                checked={photo !== "True"}
                                value="False"
                                onClick={(e) => setPhoto(e.target.value)}
                              />
                              False
                            </label>
                          </div>
                        }
                      </div>
                      <div style={{ marginLeft: 30 }} className="info-pair">
                        {" "}
                        <span className="cyan">
                          Actual appointment date:{" "}
                        </span>{" "}
                        {editCaseInfo
                          ? CustomTextField(apptDate, setApptDate)
                          : apptDate}{" "}
                      </div>
                    </div>
                    <div style={{ display: "flex", marginTop: 5 }}>
                      <div className="info-pair">
                        {" "}
                        <span className="cyan">Procheck Comment: </span>{" "}
                        {procheckComment}{" "}
                      </div>
                    </div>
                    <div style={{ display: "flex", marginTop: 5 }}>
                      <div className="info-pair">
                        {" "}
                        <span className="cyan">Comments: </span>{" "}
                        {editCaseInfo
                          ? CustomTextField(comment, setComment)
                          : comment}{" "}
                      </div>
                    </div>
                  </div>

                  <div style={{
                    display: "flex",
                    flexDirection: "column",  
                    alignItems: "center",
                    justifyContent: "center",               
                  }}>
                    {isFitnessDropdownNeeded && <div className="pehcDropdownDiv" style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      justifyContent: "center",
                    }}>
                      <span style={{ fontWeight: "bold", fontSize: "14px"}}>
                        PEHC Options: <span style={{ color: "red" }}>*</span>
                      </span>
                      <Select
                        value={pehcDropdownValue}
                        onChange={(e) => setPehcDropdownValue(e.target.value)}
                        size="small"
                        displayEmpty
                        style={{ 
                          minWidth: "180px", 
                          fontSize: "14px",
                          height: "32px"
                        }}
                        inputProps={{ style: { color: "white", fontSize: "14px" } }}
                        endAdornment={
                          pehcDropdownValue ? (
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                setPehcDropdownValue("");
                              }}
                              style={{
                                padding: "2px",
                                color: "#000",
                                backgroundColor: "#ccc",
                                marginRight: "24px"
                              }}
                            >
                              <CloseIcon style={{ fontSize: "0.5em" }} />
                            </IconButton>
                          ) : null
                        }
                      >
                        <MenuItem value="">
                          <em>Select an option</em>
                        </MenuItem>
                        {pehcDropdownOptions.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </div>
                  }

                    <div className="testNamesDiv">
                      <span style={{ fontWeight: "bold", fontSize: "18px" }}>
                        Test List:
                      </span>
                      {testList.map((testName) => (
                        <div className="testListItem" style={{ fontSize: "15px" }}>{testName}</div>
                      ))}
                    </div>

                  </div>
                </div>
                <div className="sutestTableDiv">
                <CollapsibleTable
                  caseId={caseId}
                  editable={editable}
                  pastUser={pastUser}
                  state={state}
                  handlePageChange={handlePageChange}
                  isOpen={isOpen}
                  setIsOpen={setIsOpen}
                  profile={profile}
                  profileName={profileName}
                  rows={rows} 
                  setRows={setRows}
                  rows2={rows2}
                  setRows2={setRows2}
                  assignSnackbarContent={assignSnackbarContent}
                  hasMER={hasMer}
                  anomalyThresholdValue={anomalyThresholdValue}
                  repeatCaseCount={repeatCaseCount}
                  nonWhite = {nonWhite}
                  setnonWhite={setnonWhite}
                />
              </div>

             
                <Backdrop
                  sx={{
                    color: "#fff",
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                  }}
                  open={stateUpdate}
                >
                  <CircularProgress />
                </Backdrop>
                <Snackbar
                  open={openSnackbar}
                  autoHideDuration={3000}
                  onClose={handleCloseSnackbar}
                  action={action}
                  message={message}
                />
              </div>
            </div>
          </div>
        )
      ) : (
        <div style={{ margin: "10rem", textAlign: "center" }}>
          <h1>You do not have access to view this case.</h1>
          <h3>
            Return to caselist : <Link to="/caselist">Caselist</Link>
          </h3>
        </div>
      )}
    </>
  );
};

export default CaseDetails;



